module.exports = __webpack_public_path__ + "img/86.76db5735.png";